export const FilledHeart = () => (
  <svg
    fill="#ffffff"
    xmlns="http://www.w3.org/2000/svg"
    height={31}
    viewBox="0 -960 960 960"
    width={31}
    opacity="0.8"
  >
    <path d="M480-147q-14 0-28.5-5T426-168l-69-63q-106-97-191.5-192.5T80-634q0-94 63-157t157-63q53 0 100 22.5t80 61.5q33-39 80-61.5T660-854q94 0 157 63t63 157q0 115-85 211T602-230l-68 62q-11 11-25.5 16t-28.5 5Z" />
  </svg>
)